import BaseClass from "../BaseClass.js";

export default class ContentAutoloadContainer extends BaseClass {

    constructor(element) {
        super(element);

        this.contentUrl = this.$element.attr('data-url');
        this.currentPage = 0;
        this.nextPage = 0;

        this.nextLoadMarker = null;
        this.scrollListener = null;
        this.contentScrolledListener = null;
        this.contentResizedListener = null;

        this.loading = false;
        this.postData = null;
        this.jqxhr = null;
        this.containerWidth = 0;
        this.windowWidth = 0;

        this.init();
    }

    init() {
        let currentPage = this.$element.attr('data-currentpage');
        if (currentPage != undefined) {
            this.currentPage = currentPage;
        }

        let nextPage = this.$element.attr('data-nextpage');
        if (nextPage != undefined) {
            this.nextPage = nextPage;
        }

        let additionalData = this.$element.attr('data-additional');
        if (additionalData != undefined && additionalData.length > 0) {
            this.setadditionalData(additionalData);
        }

        this.setWidthData();
        this.createListener();
        this.loadContent();
        let mySelf = this;

        let mutationObserver = new MutationObserver(function (mutations) {
            if (1 == mutations.length) {
                let removedNodes = mutations[0].removedNodes;

                if (1 == removedNodes.length) {
                    let removedNode = $(removedNodes[0]);

                    if (removedNode.data('autoload-element') != undefined) {
                        let autoloadElements = mySelf.$element.find('[data-autoload-element]');

                        if (0 == autoloadElements.length) {
                            $(document).trigger('content:scrolled');
                        }
                    }
                }
            }
        });
        mutationObserver.observe(document.body, {childList: true, subtree: true});
    }

    setadditionalData(additionalData) {
        this.postData = additionalData;
    }

    setWidthData() {
        this.containerWidth = this.$element.innerWidth();
        this.windowWidth = $(window).innerWidth();
    }

    createListener() {
        let $document = $(document);
        let mySelf = this;

        this.scrollListener = function () {
            $(window).trigger('scroll');
        };

        this.contentScrolledListener = function () {
            mySelf.trackWindowScroll();
        };

        this.contentResizedListener = function () {
            mySelf.setWidthData();
            mySelf.trackWindowScroll();
        };

        this.$element.on('scroll', this.scrollListener);
        $document.on('content:scrolled', this.contentScrolledListener);
        $document.on('content:resized', this.contentResizedListener);
    }

    trackWindowScroll() {
        if (this.nextLoadMarker === null) {
            return;
        }

        if (this.isVisible($(window), $(this.nextLoadMarker), 10, 1, 0)) {
            this.loadContent();
        }
    }

    loadContent() {
        const mySelf = this;

        if (this.loading) {
            return false;
        }

        if (this.nextPage > 0 && this.currentPage === this.nextPage) {
            return false;
        }

        this.showLoadMarker();

        this.loading = true;
        let requestUrl = this.contentUrl;
        requestUrl += '/' + this.nextPage;

        let autoloadElements = mySelf.$element.find('[data-autoload-element]');
        requestUrl += '/' + autoloadElements.length;

        let requestData = this.postData;
        requestData += '&containerWidth=' + this.containerWidth;
        requestData += '&windowWidth=' + this.windowWidth;

        if (this.elementID != null) {
            requestData += '&containerID=' + this.elementID;
        }

        this.jqxhr = $.post(requestUrl, requestData, function () {
        }, 'html')
            .done(function (data) {
                mySelf.appendData(data, mySelf.nextPage, requestUrl, requestData);
                mySelf.loading = false;
                mySelf.jqxhr = null;
            })
            .fail(function (data) {
                mySelf.removeLoadMarker();
                mySelf.appendData(data.responseText, 0, requestUrl, requestData, true);
                mySelf.loading = false;
                mySelf.jqxhr = null;
            })
            .always(function () {
            });
    }

    showLoadMarker() {
        let $elements = this.$element.find('[data-type="autoloadNext"]');
        $elements.children('.hidden').removeClass('hidden');
    }

    appendData(data, page, contentUrl, requestData, failed = false) {
        if (failed) {
            this.$element.append(data);
            return;
        }

        this.removeLoadMarker();
        this.$element.append(data);
        $(document).trigger('content:loaded', {elementID: this.$element.attr('id')});

        this.initLoadViewListener();
        $(document).trigger('content:loaded', {elementID: this.elementID});
    }

    removeLoadMarker() {
        this.$element.children('[data-type="autoloadFirst"]').addClass('hidden');
        this.$element.children('[data-type="autoloadNext"]').remove();
        this.nextLoadMarker = null;
    }

    initLoadViewListener() {
        let $nextLoadMarker = this.$element.children('[data-type="autoloadNext"]');

        if ($nextLoadMarker.length === 1) {
            this.nextLoadMarker = $nextLoadMarker;
            this.currentPage = this.nextLoadMarker.attr('data-currentpage');
            this.nextPage = this.nextLoadMarker.attr('data-nextpage');
            this.nextLoadMarker.css('minHeight', '100px');
        } else {
            if (this.scrollListener != null) {
                this.$element.off('scroll', this.scrollListener);
            }

            if (this.contentScrolledListener != null) {
                $(document).off('content:scrolled', this.contentScrolledListener);
                this.contentScrolledListener = null;
            }
        }
    }

    destroyListener() {
        let $document = $(document);

        if (this.scrollListener != null) {
            this.$element.off('scroll', this.scrollListener);
        }

        if (this.contentScrolledListener != null) {
            $document.off('content:scrolled', this.contentScrolledListener);
        }

        if (this.contentResizedListener != null) {
            $document.off('content:resized', this.contentResizedListener);
        }
    }
}